import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CodeEditorModule } from '@portal-core/code-editor/components/code-editor/code-editor.module';
import { CodeEditorStatusBarModule } from '@portal-core/code-editor/components/code-editor-status-bar/code-editor-status-bar.module';
import { FlareTextEditorModule } from '@portal-core/project-files/components/flare-text-editor/flare-text-editor.module';
import { FlareXmlEditorComponent } from './flare-xml-editor.component';

@NgModule({
  declarations: [
    FlareXmlEditorComponent
  ],
  imports: [
    CodeEditorModule,
    CodeEditorStatusBarModule,
    CommonModule,
    FlareTextEditorModule
  ],
  exports: [
    FlareXmlEditorComponent
  ]
})
export class FlareXmlEditorModule { }
